import React from "react";
import { Breadcrumb, Col, Row } from "antd";
import { RightOutlined } from "@ant-design/icons";

const LayoutBreadCrumb = (props) => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  const renderBreadCrumb = () => {
    return (
      <Breadcrumb className="breadcrumb" separator={<RightOutlined />}>
        {props?.data?.map((item) => {
          const title = item?.title || "";
          const url = item?.url || "#";
          return (
            <Breadcrumb.Item key={title}>
              {url ? (
                <a href={url} target="_self" rel="noopener noreferrer">
                  {title}
                </a>
              ) : (
                title
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[30, 0]} className="page-header-container">
      <Col span={24}>{renderBreadCrumb()}</Col>
    </Row>
  );
};

export default LayoutBreadCrumb;
